export const LOAD_ORDER_DETAILS_REQUEST = 'OrderDetails/LOAD_ORDER_REQUEST';
export const LOAD_ORDER_DETAILS_SUCCESS = 'OrderDetails/LOAD_ORDER_SUCCESS';
export const LOAD_ORDER_DETAILS_ERROR = 'OrderDetails/LOAD_ORDER_ERROR';

export const CANCEL_ORDER_REQUEST = 'OrderDetails/CANCEL_ORDER_REQUEST';
export const CANCEL_ORDER_SUCCESS = 'OrderDetails/CANCEL_ORDER_SUCCESS';
export const CANCEL_ORDER_ERROR = 'OrderDetails/CANCEL_ORDER_ERROR';
